<app-page-layout 
	[title]="title"
	[subtitle]="subtitle"
	[heroImage]="heroImage"
	[breadcrumbs]="breadcrumbs"
	[prevPage]="prevPage"
	[nextPage]="nextPage">

	<div class="intro-strip">
		<p>
			Un courtier en assurance composé d'une équipe très expériementée en <strong>assurance professionnelle, particulier et assurance entreprise</strong>
			pour vous proposer les contrats d'assurance les mieux adaptés à vos besoins.
		</p>
	</div>

	<div class="content-wrapper">
		<h2>Avantages courtier assurance :</h2>
		<p>
			Le courtier en assurance Brokins apporte des solutions aux problèmes constatés par les assurés dans leur démarche de couverture de leurs risques, 
			mais également dans leur relation avec l'assurance en général. En effet, nous avons constatés différents écueils rencontrés par l'assuré dans son 
			parcours d'achat d'assurance.
		</p>
		<p>
			<strong>Le courtier en assurance BROKINS est justement là pour aider ses clients à faire face à tous ces écueils :</strong>
		</p>

		<div class="features-grid">
			<div class="feature">
				<h4><i class="pi pi-question-circle"></i> Complexité</h4>
				<p>La complexité pour comprendre les produits d'assurance, qui sont des produits dits « complexes » ou viennent se greffer des paramètres juridiques, fiscaux, sociaux, commerciaux, et actuariels. 5 % des assurés disent comprendre leur contrat d'assurance Auto, Moto, Protection Juridique, Décennale, Immeuble, Habitation,...</p>
			</div>

			<div class="feature">
				<h4><i class="pi pi-clock"></i> Manque de temps</h4>
				<p>Le manque de temps qui fait que vous souhaiteriez que cette formalité administrative d'assurance prenne le moins de temps possible, ce qui vous permettrait de réaliser des activités jugées plus intéressante ou récréative.</p>
			</div>

			<div class="feature">
				<h4><i class="pi pi-shield"></i> Manque de confiance</h4>
				<p>Le manque de confiance accordé aux assureurs, alors que vous leur confiez la protection matérielle, immatérielle, financière, et humaine de votre vie. Ce manque de confiance liée à la non-adéquation du produit proposé au regard du besoin exprimé, du montant de la cotisation surévalué au regard du besoin exprimé, du manque d'indépendance du courtier dans le conseil prodigué, des services proposés post-souscription, et enfin des moyens technologiques de sécurité de la transaction et de la confidentialité des données communiquées.</p>
			</div>

			<div class="feature">
				<h4><i class="pi pi-sync"></i> Manque de réactivité et interactivité</h4>
				<p>Le manque de réactivité de la part du professionnel d'assurance et d'interactivité entre vous après la signature du contrat, qui est souvent réduit généralement à un seul échange, lors de la survenance d'un sinistre.</p>
			</div>

			<div class="feature">
				<h4><i class="pi pi-star"></i> Manque de services</h4>
				<p>Le manque de services à fortes valeurs ajoutées que vous êtes en droit d'attendre d'un professionnel de l'assurance. 14 % des assurés seulement disent avoir du conseil dans la gestion de leurs risques (Auto, Moto, Habitation, Santé...).</p>
			</div>

			<div class="feature">
				<h4><i class="pi pi-lock"></i> Manque d'autonomie</h4>
				<p>Le manque d'autonomie dans la réalisation d'actions simples sur ses contrats d'assurance comme la demande de changement de RIB, la demande d'une attestation, la demande d'une résiliation, la récupération des factures de paiements etc.</p>
			</div>
		</div>

		<div class="cta-bottom">
			<a class="btn-primary" [routerLink]="['/notre-equipe']">Notre équipe</a>
			<a class="btn-secondary" [routerLink]="['/notre-approche']">En savoir plus</a>
		</div>
	</div>

</app-page-layout>
